/* ============================================================
   DOWNLOW & CO. — storefront JS
   Real Shopify AJAX cart + drawer, mobile menu, PDP gallery,
   bundle selector. No framework.
   ============================================================ */
/* Downlow & Co. storefront — build 2 */
(function () {
  'use strict';

  var R = window.dlcRoutes || { cartAdd: '/cart/add.js', cartChange: '/cart/change.js', cart: '/cart.js' };

  function money(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------------- Cart ---------------- */
  var Cart = {
    root: null,
    init: function () {
      this.root = document.getElementById('CartRoot');
      this.refresh();
    },
    open: function () { if (this.root) this.root.classList.add('is-open'); document.body.style.overflow = 'hidden'; },
    close: function () { if (this.root) this.root.classList.remove('is-open'); document.body.style.overflow = ''; },
    setCount: function (n) {
      $all('[data-cart-count]').forEach(function (el) { el.textContent = n; });
    },
    add: function (id, qty) {
      var self = this;
      return fetch(R.cartAdd, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: id, quantity: qty || 1 })
      }).then(function (r) { return r.json(); }).then(function () {
        return self.refresh(true);
      });
    },
    addMany: function (items) {
      var self = this;
      return fetch(R.cartAdd, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { return r.json(); }).then(function () {
        return self.refresh(true);
      });
    },
    change: function (key, qty) {
      var self = this;
      return fetch(R.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); }).then(function (cart) {
        self.render(cart);
        return cart;
      });
    },
    refresh: function (openAfter) {
      var self = this;
      return fetch(R.cart, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          self.render(cart);
          if (openAfter) self.open();
          return cart;
        });
    },
    render: function (cart) {
      this.setCount(cart.item_count);
      if (!this.root) return;
      this.root.setAttribute('data-empty', cart.item_count === 0 ? 'true' : 'false');

      var list = $('[data-cart-items]', this.root);
      if (list) {
        list.innerHTML = cart.items.map(function (item) {
          var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x150$1$2') : '';
          return (
            '<div class="dlc-lineitem">' +
              '<div class="dlc-lineitem__img">' + (img ? '<img src="' + img + '" alt="' + escapeHtml(item.title) + '">' : '') + '</div>' +
              '<div class="dlc-lineitem__main">' +
                '<div class="dlc-lineitem__top">' +
                  '<a class="dlc-lineitem__name" href="' + item.url + '">' + escapeHtml(item.product_title) + '</a>' +
                  '<button class="dlc-lineitem__remove" data-line-remove="' + item.key + '" aria-label="Verwijder">✕</button>' +
                '</div>' +
                '<div class="dlc-lineitem__price">' + money(item.final_price) + '</div>' +
                '<div class="dlc-lineitem__row">' +
                  '<div class="dlc-qty">' +
                    '<button data-line-dec="' + item.key + '" data-qty="' + item.quantity + '" aria-label="Minder">−</button>' +
                    '<span>' + item.quantity + '</span>' +
                    '<button data-line-inc="' + item.key + '" data-qty="' + item.quantity + '" aria-label="Meer">+</button>' +
                  '</div>' +
                  '<div class="dlc-lineitem__total">' + money(item.final_line_price) + '</div>' +
                '</div>' +
              '</div>' +
            '</div>'
          );
        }).join('');
      }
      var sub = $('[data-cart-subtotal]', this.root);
      if (sub) sub.textContent = money(cart.total_price);
    }
  };

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------------- Mobile menu ---------------- */
  function toggleMenu(force) {
    var m = document.getElementById('MobileMenu');
    if (!m) return;
    var open = force !== undefined ? force : !m.classList.contains('is-open');
    m.classList.toggle('is-open', open);
  }

  /* ---------------- Wire up ---------------- */
  /* ---------------- Gallery slider ---------------- */
  function initSliders() {
    $all('[data-slider]').forEach(function (slider) {
      var track = slider.querySelector('[data-slider-track]');
      var dots = $all('[data-slider-dot]', slider);
      if (!track || dots.length < 2) return;

      var raf;
      function update() {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === i); });
      }
      track.addEventListener('scroll', function () {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(update);
      });
      dots.forEach(function (d) {
        d.addEventListener('click', function () {
          var idx = parseInt(d.getAttribute('data-slider-dot'), 10);
          track.scrollTo({ left: idx * track.clientWidth, behavior: 'smooth' });
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    Cart.init();
    initSliders();

    document.addEventListener('click', function (e) {
      var t = e.target;

      // open / close cart
      var openBtn = t.closest('[data-cart-open]');
      if (openBtn) { e.preventDefault(); Cart.open(); return; }
      if (t.closest('[data-cart-close]')) { e.preventDefault(); Cart.close(); return; }

      // menu
      var mt = t.closest('[data-menu-toggle]');
      if (mt) { e.preventDefault(); toggleMenu(); return; }
      var mc = t.closest('[data-menu-close]');
      if (mc) {
        toggleMenu(false);
        // Let real links navigate; only block the overlay/non-link closers.
        var isLink = mc.tagName === 'A' && mc.getAttribute('href');
        if (!isLink) e.preventDefault();
        return;
      }

      // quantity controls in drawer
      var dec = t.closest('[data-line-dec]');
      if (dec) { Cart.change(dec.getAttribute('data-line-dec'), Math.max(0, parseInt(dec.getAttribute('data-qty'), 10) - 1)); return; }
      var inc = t.closest('[data-line-inc]');
      if (inc) { Cart.change(inc.getAttribute('data-line-inc'), parseInt(inc.getAttribute('data-qty'), 10) + 1); return; }
      var rem = t.closest('[data-line-remove]');
      if (rem) { Cart.change(rem.getAttribute('data-line-remove'), 0); return; }

      // PDP gallery thumbs (desktop)
      var thumb = t.closest('[data-thumb]');
      if (thumb) {
        var main = document.getElementById('PdpMain');
        if (main) main.src = thumb.getAttribute('data-thumb');
        $all('[data-thumb]').forEach(function (el) { el.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        return;
      }

      // PDP bundle option selector
      var opt = t.closest('[data-opt]');
      if (opt) {
        var box = opt.closest('[data-buybox]');
        if (box) {
          $all('[data-opt]', box).forEach(function (el) { el.classList.remove('is-active'); });
          opt.classList.add('is-active');
          var idField = $('[data-variant-field]', box);
          if (idField) idField.value = opt.getAttribute('data-variant-id');
          var cta = $('[data-cta-text]', box);
          if (cta) cta.textContent = opt.getAttribute('data-cta-label') || cta.textContent;
        }
        return;
      }
    });

    // add-to-cart forms (product cards, PDP, FBT)
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[data-cart-form]');
      if (!form) return;
      e.preventDefault();

      var btn = form.querySelector('[type="submit"]');
      if (btn && btn.disabled) return;

      // multi-item (frequently bought together)
      var multi = form.getAttribute('data-items');
      if (multi) {
        var items = JSON.parse(multi);
        if (btn) btn.disabled = true;
        Cart.addMany(items).then(function () { if (btn) btn.disabled = false; });
        return;
      }

      var idInput = form.querySelector('[name="id"]');
      var qtyInput = form.querySelector('[name="quantity"]');
      if (!idInput || !idInput.value) return;
      if (btn) btn.disabled = true;
      Cart.add(idInput.value, qtyInput ? parseInt(qtyInput.value, 10) : 1)
        .then(function () { if (btn) btn.disabled = false; });
    });
  });

  window.DLCCart = Cart;
})();
